{
  "error": "Fehler",
  "help": "Hilfe",
  "info": "Informationen",
  "success": "Erfolg",
  "warning": "Warnung"
}
